<template>
  <div v-if="dialog" class="rcp-modal" @keydown.esc.stop.prevent="ctl.cancelDialog" @keydown.tab="keepFocus">
    <div class="rcp-modal__scrim" @click="ctl.cancelDialog"></div>
    <div ref="box" class="rcp-modal__box" role="alertdialog" aria-modal="true" aria-labelledby="rcp-dlg-title" aria-describedby="rcp-dlg-text" tabindex="-1">
      <h2 id="rcp-dlg-title">{{ $t("recipes_shell.dialog.title") }}</h2>
      <p id="rcp-dlg-text">
        {{ ctl.pluralT("recipes_shell.dialog.have", ctl.editTotal) }}
        {{ $t(`recipes_shell.dialog.why_${dialog.why}`) }}
        {{ $t("recipes_shell.dialog.after") }}
      </p>
      <div class="rcp-modal__foot">
        <button ref="stay" type="button" class="ui-btn" @click="ctl.cancelDialog">{{ $t("recipes_shell.dialog.stay") }}</button>
        <button type="button" class="ui-btn ui-btn--primary" @click="ctl.confirmDialog">{{ $t("recipes_shell.dialog.confirm") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Pitanje prije nego što promjena perioda, prikaza ili osvježavanje obrišu izmijenjene porcije.
 * Fokus ide na "Ostani" (bezbjedniji izbor), Tab ostaje unutar dijaloga, Esc i zavjesa otkazuju.
 */
export default {
  name: "RecipesDialog",
  inject: { ctl: "recipesCtl" },
  computed: {
    dialog() {
      return this.ctl.dialog;
    },
  },
  watch: {
    dialog(next) {
      if (next) {
        this.opener = document.activeElement;
        this.$nextTick(() => this.$refs.stay?.focus());
      } else if (this.opener && document.contains(this.opener)) {
        const opener = this.opener;
        this.opener = null;
        this.$nextTick(() => opener.focus());
      }
    },
  },
  methods: {
    keepFocus(event) {
      const box = this.$refs.box;
      if (!box) {
        return;
      }
      const items = [...box.querySelectorAll("button")];
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },
  },
};
</script>
